<!-- 旅游集市详情页  mjs -->
<template>
 <div class="travelServe touristmarketDetailcontainer pb100">
    <!-- <div class="crumbs-1">
      <div class="container">
        <a href="/show/index">首页</a>
        <span>&gt;</span>
        <a href="#">旅游集市</a>
        <span>&gt;</span>
        <a href="#">详情页</a>
      </div>
    </div> -->
    <crumbs detail="true"/>

    <div class="container">
      <div class="Cleft marketCleft">
     <div class="content marketconent clearfix">

        <!--banner-->
        <div class="banner">
          <!-- Swiper -->
          <swiper :options="swiperOption1"  ref="swiperTop" class="swiper-container gallery-top">
            <!-- <div class="swiper-wrapper" id="bgImg"> -->
              <swiper-slide class="swiper-slide" v-for="(item,index) in imgList" :key="index + 'mm'">
                <img :src="getImage(item)"  alt="">
              </swiper-slide>

            <!-- </div> -->
          </swiper>
          <swiper :options="swiperOption2" ref="swiperThumbs" class="swiper-container gallery-thumbs">
            <!-- <div class="swiper-wrapper" id="smImg"> -->
                <swiper-slide class="swiper-slide" v-for="(item,index) in imgList" :key="index + 'jj'">
                 <img :src="getImage(item)"  alt="">
                </swiper-slide>
            <!-- </div> -->
          </swiper>
        </div>

        <!--desc-->
        <div class="desc">
          <div class="ditemtxt">

            <div class="title clearfix">
              <h2>{{marketdetail.title}}</h2>
            </div>
               <!-- <div class="itemfun clearfix">
                      <span class="browsevalue">
                        <i></i><em>1</em>
                      </span>
                      <span class="praisevalue" id="praisevalue">
                          <i></i>
                          <em>0</em>
                      </span>
                      <span class="collection" id="collection">
                          <i></i>
                          <em>0</em>
                      </span>
                </div> -->
            <ul class="otherul">
              <li>售卖景区：{{marketdetail.vendors}}</li>
              <li>建议价格：<span><i>￥</i>{{marketdetail.price}}</span></li>
              <li>主要材质：{{marketdetail.material}}</li>
              <li>尺寸：{{marketdetail.size}}</li>
            </ul>
          </div>
          <div class="buyBtn clearfix" v-if="marketdetail.link !== undefined && marketdetail.link!==''">
            <a href="javascript:;" class="buylink" @click="gobuy(marketdetail.link)">购买</a>
          </div>
        </div>
      </div>

      <div class="dbttom" >
        <div class="title"><span> <a :href="marketdetail.link">商品详情</a> </span><i></i></div>
      </div>
      <div class="contentbox" v-html="marketdetail.content">

      </div>

       <!-- 评论 组件引入 -->
      <comment v-if="marketdetail" comment-show="isCommentshow" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
      </div>
      <right-sidebar @pvcount="pvcount" :comment-count="commentTotal" :comment-gotop="commentOffsettop" :comment-show="isCommentshow" ref="rightSidebar"
      :title="marketdetail.title"
      :image="getImage(marketdetail.image)"
      :url="this.$route.fullPath"
      ></right-sidebar>
       <go-top></go-top>

    </div>
 </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import {getmarketdetail} from '@/api/touristmarket'
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'touristmarketdetail',
  components: {
    Comment, RightSidebar, goTop, crumbs, swiper, swiperSlide
  },
  data () {
    return {
      id: '',
      appointment: '',
      commentId: 1,
      marketdetail: {},
      swiperOption1: {
        spaceBetween: 10,
        // thumbs: {
        //     swiper:this.swiperOption2,
        // },
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: false,
        // },
        grabCursor: true
      },
      swiperOption2: {
        grabCursor: true, // 鼠标覆盖Swiper时指针会变成手掌形状
        centeredSlides: false,
        slidesPerView: 3, // 同时显示的数量
        touchRatio: 0.2,
        slideToClickedSlide: true,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      pv: '',
      commentTotal: '',
      commentOffsettop: '',
      isCommentshow: true,
      imgList: []
    }
  },
  meta: {
    showHeader: true
  },
  created () {
    this.id = this.$route.query.id
    this.getdetail()
  },
  mounted () {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$el.swiper
      const swiperThumbs = this.$refs.swiperThumbs.$el.swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  methods: {
    getdetail () {
      getmarketdetail(this.id).then(res => {
        console.log(res)
        this.marketdetail = res.data.data
        this.imgList = res.data.data.images.split('|')
      })
    },
    getImage (val) {
      if (val === undefined || val === '') {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    commentCount (val) {
      this.commentTotal = val
    },
    pvcount (val) {
      this.pv = val
    },
    gobuy (url) {
      window.open(url)
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import "../../assets/common/scss/travleServes.scss";
</style>



// WEBPACK FOOTER //
// src/view/touristmarket/detail.vue